import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import ApplicationsMob1x from './builder-applications-mob@1x.png'
import ApplicationsMob2x from './builder-applications-mob@2x.png'
import ApplicationsDesk1x from './builder-applications-desk@1x.png'
import ApplicationsDesk2x from './builder-applications-desk@2x.png'
import classes from './BuilderApplications.module.scss'

export const BuilderApplications = () => {
  return (
    <Block as={'section'} variant={'solidMob'} pad={'baseMob'}>
      <Heading as={'h3'} center balance size={'xl'} className={classes.title}>
        Extend existing connectors
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        Don't start from scratch. Many applications already have a connector
        built. You can add functionality that is missing for you.
      </Text>

      <picture className={classes.image}>
        <source
          media='(min-resolution: 2dppx) and (min-width: 768px)'
          srcSet={ApplicationsDesk2x.src}
        />
        <source media='(min-width: 768px)' srcSet={ApplicationsDesk1x.src} />
        <source
          media='(min-resolution: 2dppx) and (max-width: 767px)'
          srcSet={ApplicationsMob2x.src}
        />
        <source media='(max-width: 767px)' srcSet={ApplicationsMob1x.src} />
        <img
          className={classes.image}
          src={ApplicationsMob1x.src}
          alt='Applications'
          width={1440}
          height={376}
          loading='lazy'
        />
      </picture>
    </Block>
  )
}
